import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import RequestQuoteListing from "../Quote/RequestQuoteListing";
import QuickBookEstimateList from "../QuickBooks/QuickBookEstimate";
import QuickBookInvoiceList from "../QuickBooks/InvoiceList";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import methodModel from "../../methods/methods";
import { SlLock } from "react-icons/sl";
import OrderTrackingList from "../OrderTracking/OrderTrackingList";

const AllTabs = [
  {
    name: "Request To Quote",
    id: "request_quote",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className=""
        className="w-[14px] sm:w-[17px] relative sm:top-[-2px]"
        viewBox="0 0 23 22"
        fill="none"
      >
        <path
          d="M21.375 0C21.996 0 22.5 0.504 22.5 1.125V16.875C22.5 17.496 21.996 18 21.375 18H5.01188L0 21.9375V1.125C0 0.504 0.504 0 1.125 0H21.375ZM10.0822 5.7375L9.57938 4.9635C7.569 5.83538 6.1875 7.59938 6.1875 9.56812C6.1875 10.6875 6.49913 11.3783 7.0785 11.9936C7.443 12.3806 8.02013 12.6562 8.62425 12.6562C9.711 12.6562 10.593 11.7743 10.593 10.6875C10.593 9.6525 9.79313 8.81888 8.77725 8.72437C8.59725 8.7075 8.41275 8.71088 8.23837 8.73563V8.63213C8.24512 8.15738 8.34188 6.795 9.87413 5.85787L10.0822 5.7375ZM15.2044 4.9635C13.194 5.83538 11.8125 7.59938 11.8125 9.56812C11.8125 10.6875 12.1241 11.3783 12.7035 11.9936C13.068 12.3806 13.6451 12.6562 14.2493 12.6562C15.336 12.6562 16.218 11.7743 16.218 10.6875C16.218 9.6525 15.4181 8.81888 14.4023 8.72437C14.2222 8.7075 14.0378 8.71088 13.8634 8.73563C13.8634 8.3835 13.8307 6.75338 15.7072 5.7375L15.2044 4.9635Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Estimate",
    id: "estimate",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className=""
        className="w-[14px] sm:w-[17px] relative sm:top-[-2px]"
        viewBox="0 0 23 23"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2917 10.7812C19.3334 10.7812 21.8021 13.2499 21.8021 16.2917C21.8021 19.3334 19.3334 21.8021 16.2917 21.8021C13.2499 21.8021 10.7812 19.3334 10.7812 16.2917C10.7812 13.2499 13.2499 10.7812 16.2917 10.7812ZM15.5729 13.8958V16.2917C15.5729 16.6884 15.8949 17.0104 16.2917 17.0104H18.6875C19.0843 17.0104 19.4062 16.6884 19.4062 16.2917C19.4062 15.8949 19.0843 15.5729 18.6875 15.5729H17.0104V13.8958C17.0104 13.4991 16.6884 13.1771 16.2917 13.1771C15.8949 13.1771 15.5729 13.4991 15.5729 13.8958Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.98828 2.39567V1.9165C5.98828 1.51975 6.31028 1.19775 6.70703 1.19775C7.10378 1.19775 7.42578 1.51975 7.42578 1.9165V2.39567H5.98828Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5723 2.39567V1.9165C15.5723 1.51975 15.8943 1.19775 16.291 1.19775C16.6878 1.19775 17.0098 1.51975 17.0098 1.9165V2.39567H15.5723Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9469 21.0833H3.83268C3.13406 21.0833 2.46322 20.8053 1.96872 20.3118C1.47518 19.8173 1.19727 19.1465 1.19727 18.4478V8.14575H21.8014V12.9039C20.662 11.0553 18.6198 9.82283 16.291 9.82283C12.7212 9.82283 9.82227 12.7218 9.82227 16.2916C9.82227 18.19 10.6426 19.8997 11.9469 21.0833ZM1.19727 6.70825V5.03117C1.19727 4.33254 1.47518 3.66171 1.96872 3.16721C2.46322 2.67367 3.13406 2.39575 3.83268 2.39575H5.98893V4.31242C5.98893 4.70917 6.31093 5.03117 6.70768 5.03117C7.10443 5.03117 7.42643 4.70917 7.42643 4.31242V2.39575H15.5723V4.31242C15.5723 4.70917 15.8943 5.03117 16.291 5.03117C16.6878 5.03117 17.0098 4.70917 17.0098 4.31242V2.39575H19.166C19.8646 2.39575 20.5355 2.67367 21.03 3.16721C21.5235 3.66171 21.8014 4.33254 21.8014 5.03117V6.70825H1.19727Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Invoice",
    id: "invoice",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className=""
        className="w-[14px] sm:w-[17px] relative sm:top-[-2px]"
        viewBox="0 0 23 23"
        fill="none"
      >
        <path
          d="M19.3426 0H9.79949V6.47468C9.79949 6.90323 9.45206 7.25066 9.02351 7.25066H2.54883V21.8915C2.54883 22.5037 3.04517 23 3.65737 23H19.3426C19.9548 23 20.4511 22.5037 20.4511 21.8915V1.10854C20.4511 0.496342 19.9548 0 19.3426 0ZM14.9733 18.4073H8.65524C8.22668 18.4073 7.87926 18.0599 7.87926 17.6313C7.87926 17.2028 8.22668 16.8554 8.65524 16.8554H14.9733C15.4019 16.8554 15.7493 17.2028 15.7493 17.6313C15.7493 18.0599 15.4019 18.4073 14.9733 18.4073ZM14.9733 14.7569H8.65524C8.22668 14.7569 7.87926 14.4095 7.87926 13.9809C7.87926 13.5524 8.22668 13.205 8.65524 13.205H14.9733C15.4019 13.205 15.7493 13.5524 15.7493 13.9809C15.7493 14.4095 15.4019 14.7569 14.9733 14.7569ZM14.9733 11.1066H8.65524C8.22668 11.1066 7.87926 10.7592 7.87926 10.3306C7.87926 9.90208 8.22668 9.55466 8.65524 9.55466H14.9733C15.4019 9.55466 15.7493 9.90208 15.7493 10.3306C15.7493 10.7592 15.4019 11.1066 14.9733 11.1066Z"
          fill="currentColor"
        />
        <path
          d="M8.23818 0C7.94422 0 7.66228 0.116752 7.45439 0.32474L2.87357 4.90538C2.66567 5.11328 2.54883 5.39521 2.54883 5.68918V5.69865H8.24762V0H8.23818Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Order Tracking",
    id: "order_tracking",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-[20px] sm:w-[23px]"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14 17H6V5H14V17Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 9H18L21 12V17H14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8.5" cy="18.5" r="1.5" fill="currentColor" />
        <circle cx="17.5" cy="18.5" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
];

export default function OrderMgmt() {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const location = useLocation();

  // Derive active parameters directly from URL search params to ensure synchronization on history changes
  const searchParams = new URLSearchParams(location.search);
  const selectedTab = searchParams.get("tab") || "request_quote";
  const metaId = searchParams.get("id");
  const subTab = searchParams.get("subTab");
  const triggerDate = searchParams.get("date");
  const [quotesToken, setQuotesToken] = useState("");
  const [quotesCompanyId, setQuotesCompanyId] = useState("");

  if (!user?.email) {
    return (
      <>
        <Header />
        <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
          <div className="container mx-auto py-8">
            <div className="flex flex-col gap-1 mb-6">
              <h2 className="text-gray-900 text-xl xl:text-2xl font-semibold">
                My Documents
              </h2>
              <p className="text-gray-500 text-sm">
                Please login to manage your orders
              </p>
            </div>

            <div className="w-full">
              <div className="flex flex-col items-center justify-center py-20 gap-6 text-center">
                {/* Icon */}
                <div className="w-16 h-16 rounded-full bg-[#EBF3FB] flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite]">
                  <SlLock className="w-[28px] h-[28px]" />
                </div>

                {/* Text */}
                <div className="space-y-1.5">
                  <h3 className="text-lg font-semibold text-gray-900">
                    You are not logged in
                  </h3>
                  <p className="text-sm text-gray-500 max-w-sm">
                    Please login to view and manage your orders.
                  </p>
                </div>

                {/* Button */}
                <button
                  type="button"
                  onClick={() => history("/login")}
                  className="flex gap-2 items-center justify-center bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white rounded-full text-sm hover:scale-[1.04] duration-300 transition px-5 py-2.5"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
        {methodModel.TokenChecker() && <Footer />}
      </>
    );
  }

  const fetchQuotes = async () => {
    loader(true);
    await ApiClient.get("quickbook/express/tkn")
      .then((res) => {
        if (res?.success) {
          console.log(res?.data, "lklkllkl");
          setQuotesToken(res?.data?.quick_book_accesToken);
          setQuotesCompanyId(res?.data?.quick_book_companyId);
        }
      })
      .catch(console.error);
    loader(false);
  };

  useEffect(() => {
    fetchQuotes();
  }, []);

  return (
    <>
      <Header />
      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px]">
        <div className="container mx-auto px-5 py-10 md:pb-20">
          {/* Breadcrumb */}
          <div className="flex items-center gap-1.5 cursor-pointer font-[300] pb-5 sm:py-8">
            <p
              onClick={() => history("/")}
              className="text-sm text-[#414141] hover:opacity-80 transition-opacity"
            >
              Home
            </p>
            <svg
              width="14"
              height="14"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#9ca3af"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <p className="text-sm text-[#116DAE] font-[600]">My Documents</p>
          </div>

          <div className="w-full overflow-auto max-lg:[scrollbar-width:none] max-lg:[-ms-overflow-style:none] max-lg:[&::-webkit-scrollbar]:hidden mb-4 sm:mb-8">
            <div className="space-x-5 lg:space-x-8 flex items-center border-b-[2px] border-[#f1f1f1] mb-1">
              {AllTabs.map((tab) => {
                const isActive = selectedTab === tab.id;

                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => history(`/orders?tab=${tab.id}`)}
                    className={`whitespace-nowrap py-1.5 max-lg:text-sm text-md font-medium transition-all flex items-center gap-1
        ${isActive
                        ? "relative text-[#115B9D] after:content-[''] after:absolute after:left-0 after:bottom-[-2px] after:w-full after:border-b-[3px] after:border-[#115B9D] after:rounded-t-[5px]"
                        : "text-gray-600 hover:text-gray-700"
                      }`}
                  >
                    <span
                      className={`relative top-[-0px] ${isActive ? "text-[#115B9D]" : "text-[#7C7C7C]"
                        }`}
                    >
                      {tab.icon}
                    </span>

                    {tab.name}
                  </button>
                );
              })}
            </div>
          </div>

          {selectedTab === "request_quote" ? (
            <RequestQuoteListing quotesToken={quotesToken} />
          ) : selectedTab === "estimate" ? (
            <QuickBookEstimateList
              quotesToken={quotesToken}
              quotesCompanyId={quotesCompanyId}
              metaId={metaId}
              subTab={subTab}
              triggerDate={triggerDate}
            />
          ) : selectedTab === "order_tracking" ? (
            <OrderTrackingList />
          ) : (
            <QuickBookInvoiceList
              quotesToken={quotesToken}
              quotesCompanyId={quotesCompanyId}
              metaId={metaId}
            />
          )}
        </div>
      </div>
      {methodModel.TokenChecker() && <Footer />}
    </>
  );
}
